import React from 'react';

import OtelIcon from '../../images/icons/prometheus.svg';

export const PrometheusLogo = () => {
  return <img height="18" src={OtelIcon} alt="Prometheus logo" />;
};
